import React from 'react'
import {
  FAILED,
  NOT_WATERMARKED,
  PROCESSING,
  WATERMARK_REMOVED,
  WATERMARKED,
} from '@disco/constants/WatermarkStatusesTypes'
import ContactUsLink from 'components/ui/contact-us-link'
import type { LozengeColor } from 'components/ui/lozenge'
const playlistOptions: {
  failed: () => {
    color: LozengeColor
    text: string
    tooltip: React.ReactNode
  }
  not_watermarked: () => {
    color: LozengeColor
    icon: string
    text: string
    tooltip: React.ReactNode
  }
  processing: () => {
    color: LozengeColor
    text: string
    tooltip: string
  }
  watermark_removed: () => {
    color: LozengeColor
    strikethrough: boolean
    text: string
    tooltip: string
  }
  watermarked: () => {
    color: LozengeColor
    text: string
  }
} = {
  [WATERMARKED]() {
    return {
      color: 'blue',
      text: 'Watermarked',
    }
  },

  [WATERMARK_REMOVED]() {
    return {
      color: 'yellow',
      strikethrough: true,
      text: 'Watermarked',
      tooltip:
        'This playlist was watermarked previously but is currently not watermarked.',
    }
  },

  [NOT_WATERMARKED]() {
    return {
      color: 'yellow',
      icon: 'warning',
      text: 'Not watermarked',
      tooltip: (
        <>
          This playlist is not watermarked and contains a track that is part of
          an active watermarked playlist.
          <a className="WatermarkingStatusFlag_Link" href="#">
            Find out more
          </a>
        </>
      ),
    }
  },

  [FAILED]() {
    return {
      color: 'bold-red',
      text: 'Failed',
      tooltip: (
        <>
          Watermarking for this playlist failed. Please{' '}
          {
            <ContactUsLink intercomMsg="I’m having issues with watermarking failing on a playlist">
              contact us
            </ContactUsLink>
          }{' '}
          for assistance
        </>
      ),
    }
  },

  [PROCESSING]() {
    return {
      color: 'bold-green',
      text: 'Processing',
      tooltip: 'Watermarking for this playlist is still in progress.',
    }
  },
}
export default playlistOptions
